var _rect, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoxicon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 75,
    rx: 37.5,
    fill: "#3F0099"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 50C44.6797 50 50.5 44.1797 50.5 37C50.5 29.8203 44.6797 24 37.5 24C30.3203 24 24.5 29.8203 24.5 37C24.5 44.1797 30.3203 50 37.5 50Z",
    fill: "url(#paint0_linear_220_13318)",
    fillOpacity: 0.24,
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M37.5 35C38.0304 35 38.5391 35.2107 38.9142 35.5858C39.2893 35.9609 39.5 36.4696 39.5 37C39.5 37.5304 39.2893 38.0391 38.9142 38.4142C38.5391 38.7893 38.0304 39 37.5 39C36.9696 39 36.4609 38.7893 36.0858 38.4142C35.7107 38.0391 35.5 37.5304 35.5 37C35.5 36.4696 35.7107 35.9609 36.0858 35.5858C36.4609 35.2107 36.9696 35 37.5 35Z",
    fill: "#030014",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 22C38.0304 22 38.5391 22.2107 38.9142 22.5858C39.2893 22.9609 39.5 23.4696 39.5 24C39.5 24.5304 39.2893 25.0391 38.9142 25.4142C38.5391 25.7893 38.0304 26 37.5 26C36.9696 26 36.4609 25.7893 36.0858 25.4142C35.7107 25.0391 35.5 24.5304 35.5 24C35.5 23.4696 35.7107 22.9609 36.0858 22.5858C36.4609 22.2107 36.9696 22 37.5 22ZM37.5 48C38.0304 48 38.5391 48.2107 38.9142 48.5858C39.2893 48.9609 39.5 49.4696 39.5 50C39.5 50.5304 39.2893 51.0391 38.9142 51.4142C38.5391 51.7893 38.0304 52 37.5 52C36.9696 52 36.4609 51.7893 36.0858 51.4142C35.7107 51.0391 35.5 50.5304 35.5 50C35.5 49.4696 35.7107 48.9609 36.0858 48.5858C36.4609 48.2107 36.9696 48 37.5 48ZM50.5 35C51.0304 35 51.5391 35.2107 51.9142 35.5858C52.2893 35.9609 52.5 36.4696 52.5 37C52.5 37.5304 52.2893 38.0391 51.9142 38.4142C51.5391 38.7893 51.0304 39 50.5 39C49.9696 39 49.4609 38.7893 49.0858 38.4142C48.7107 38.0391 48.5 37.5304 48.5 37C48.5 36.4696 48.7107 35.9609 49.0858 35.5858C49.4609 35.2107 49.9696 35 50.5 35ZM24.5 35C25.0304 35 25.5391 35.2107 25.9142 35.5858C26.2893 35.9609 26.5 36.4696 26.5 37C26.5 37.5304 26.2893 38.0391 25.9142 38.4142C25.5391 38.7893 25.0304 39 24.5 39C23.9696 39 23.4609 38.7893 23.0858 38.4142C22.7107 38.0391 22.5 37.5304 22.5 37C22.5 36.4696 22.7107 35.9609 23.0858 35.5858C23.4609 35.2107 23.9696 35 24.5 35Z",
    fill: "#030014",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_220_13318",
    x1: 37.5,
    y1: 24,
    x2: 37.5,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxicon3);
export default __webpack_public_path__ + "static/media/boxicon3.25405886fb1c6e5f67ae74e4ef740f95.svg";
export { ForwardRef as ReactComponent };